import {
    UPLOAD_RIDER_DOC_START,
    UPLOAD_RIDER_DOC_SUCCESS,
    UPLOAD_RIDER_DOC_ERROR,
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
  };
  
  export default function faqOperatorReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case UPLOAD_RIDER_DOC_START:
        return {
          ...state,
          loading: true,
        };
      case UPLOAD_RIDER_DOC_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case UPLOAD_RIDER_DOC_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  